module.exports = __webpack_public_path__ + "static/media/logo--white.e3400e2b.svg";